import { buildTask as _buildTask } from "ember-concurrency/-private/async-arrow-runtime";
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { alias } from '@ember/object/computed';
import { task } from 'ember-concurrency';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';
import { fromUnixTime, format } from 'date-fns';

/**
 * @param {Class<gqlDesk>}        desk                        Required. Graphql desk model the tooltip paired to
 * @param {Class<DeskMarker>}     marker                      Required. Desk marker
 * @param {Class<Reservation>}    currentReservation          Required. Current desk reservation
 * @param {Task}                  releaseDeskReservationTask  Required. Task to release the desk reservation
 * @param {Function}              setIsChangingDesk           Required. Set the tooltip's state
 * @param {Boolean}               isChangingDesk              Optional. If user is changing their desk
 */
let EmployeeDeskScheduleTooltip = (_dec = alias('args.currentReservation.desk.id'), _dec2 = alias('args.currentReservation.id'), (_class = class EmployeeDeskScheduleTooltip extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "flashMessages", _descriptor, this);
    _initializerDefineProperty(this, "metrics", _descriptor2, this);
    _initializerDefineProperty(this, "registrations", _descriptor3, this);
    _initializerDefineProperty(this, "router", _descriptor4, this);
    _initializerDefineProperty(this, "featureConfig", _descriptor5, this);
    _initializerDefineProperty(this, "isPermanent", _descriptor6, this);
    _initializerDefineProperty(this, "isAmenitiesExpanded", _descriptor7, this);
    _initializerDefineProperty(this, "currentDeskId", _descriptor8, this);
    _initializerDefineProperty(this, "currentReservationId", _descriptor9, this);
    _defineProperty(this, "changeDeskTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        try {
          let newReservation;
          if (this.args.isPartialDayEnabled) {
            newReservation = yield this.registrations.changeDeskPartialDay(this.date, {
              currentDeskId: this.currentDeskId,
              newDeskId: this.args.desk.id,
              reservationId: this.currentReservationId
            });
          } else {
            newReservation = yield this.registrations.changeDesk(this.date, {
              currentDeskId: this.currentDeskId,
              newDeskId: this.args.desk.id,
              reservationId: this.currentReservationId
            });
          }
          this.metrics.trackEvent('Web Employee Schedule - Change Desk', {
            current_desk_id: this.currentDeskId,
            current_reservation_id: this.currentReservationId,
            new_desk_id: newReservation.desk.id,
            new_reservation_id: newReservation.id
          });
          this.args.setIsChangingDesk(false);
          this.router.transitionTo('index');
          this.flashMessages.showAndHideFlash('success', 'Desk changed');
        } catch (e) {
          this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(e));
        }
      }
    }), {
      drop: true
    }, "changeDeskTask", null));
  }
  get date() {
    // backend returns in seconds since Jan 1 1970
    return fromUnixTime(this.args.currentReservation.startTime);
  }
  get formattedDate() {
    return format(this.date, 'MMMM dd, yyyy');
  }
  get formattedTime() {
    const startTime = format(fromUnixTime(this.args.currentReservation.startTime), 'h:mmaa');
    const endTime = format(fromUnixTime(this.args.currentReservation.endTime), 'h:mmaa');
    return `${startTime} - ${endTime}`;
  }
  get hasAmenityConfig() {
    return this.featureConfig.isEnabled('desks.amenities');
  }
  get hasNeighborhoodConfig() {
    return this.featureConfig.isEnabled('desks.neighborhood');
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "metrics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "registrations", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "featureConfig", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isPermanent", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isAmenitiesExpanded", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "currentDeskId", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "currentReservationId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { EmployeeDeskScheduleTooltip as default };